import Backend from 'App/Dataman-Backend';

const {
  apiUrlProducts,
  apiUrlProductsStats,
  apiUrlProductStatuses,
  apiUrlProductImages,
  apiProductFiles,
  apiUrlProductLines,
  apiUrlRecommendedProducts,
  apiUrlProductVariations,
  apiUrlProductVariationImages,
  apiProductConsumableVariations,
  apiUrlProductMarketCountries,
  apiUrlCountriesProductMarkets,
  apiUrlMarketCountriesFiles,
  apiFiles,
  apiUrlProductOrders,
  apiProductAnalysisOrders,
  apiAnalysisTypes,
  apiOrderStatuses,
  apiUrlSuffix,
} = Backend.config;

export const IMAGE_SEARCH_SERVICE_HOST = 'https://image-based-product-search.winglegroup.com';

export const PRODUCTS_PATHS = {
  products: apiUrlProducts,
  stats: apiUrlProductsStats,
  statuses: apiUrlProductStatuses,
  images: apiUrlProductImages,
  files: apiProductFiles,
  productLines: apiUrlProductLines,
  recommended: apiUrlRecommendedProducts,
  variations: apiUrlProductVariations,
  variationImages: apiUrlProductVariationImages,
  consumableVariations: apiProductConsumableVariations,
  marketCountries: apiUrlProductMarketCountries,
  countriesProductMarkets: apiUrlCountriesProductMarkets,
  marketCountriesFiles: apiUrlMarketCountriesFiles,
  evidenceUpload: apiFiles,
  orders: apiUrlProductOrders,
  analysisOrders: apiProductAnalysisOrders,
  analysisTypes: apiAnalysisTypes,
  orderStatuses: apiOrderStatuses,
  imageSearch: `${IMAGE_SEARCH_SERVICE_HOST}/api/similar-product-search`,
  suffix: apiUrlSuffix,
};
